<template>
  <div :class="{
    'survey-sap': true,
    loading
  }">
    <h2>{{ loading ? 'Loading...' : quoteNumber }}</h2>
    <div class="row">
      <div class="col col-12">
        <h3>Summary</h3>
        <p>
          <ul>
            <li
              v-for="summary in summaries" :key="summary.key"
              :class="summary.classes"
            >
              <i
                v-if="summary.classes.includes('danger')" 
                class="fas fa-exclamation-triangle"
                role="presentation"
              />
              <i
                v-else-if="summary.classes.includes('warning')" 
                class="fas fa-eye"
                role="presentation"
              />
              <i
                v-else-if="summary.classes.includes('success')" 
                class="fas fa-check"
                role="presentation"
              />
              <i
                v-else
                class="fas fa-square"
                role="presentation"
              />
              <span>{{ summary.text }}</span>
            </li>
          </ul>
        </p>

        <a type="button" class="btn btn-black" @click="resync">
            <span v-if="rloading"><span class="fa fa-spinner fa-pulse"></span></span>
            <span v-else>Resync</span>
        </a> 
        <i>Note: After clicking Resync buttton, the syncing happens within 5minutes.</i>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <h3>Sync Logs</h3>
        <div v-if="syncLogs.length" class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Survey ID</th>
                <th>Flag</th>
                <th>Error</th>
                <th>Quote Number</th>
                <th>Survey Status</th>
                <th>Update Time</th>
                <th>Sync Date</th>
                <th>Transaction Type</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="syncLog in syncLogs" 
                :key="syncLog.ID"
                :class="syncLogClasses(syncLog)"
              >
                <td>{{ syncLog.ID }}</td>
                <td>{{ syncLog.SURVERYID }}</td>
                <td>{{ syncLog.RESFLAG }}</td>
                <td>{{ syncLog.ERRORREMAR }}</td>
                <td>{{ syncLog.QUOTENUM }}</td>
                <td>{{ syncLog.SURVEYSTATUS }}</td>
                <td>{{ syncLog.UPDATEAT }}</td>
                <td>{{ syncLog.SYNCDATE }}</td>
                <td>{{ syncLog.TRANSTYPE }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else-if="loading">Loading...</p>
        <p v-else>No sync logs found.</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <h3>Site API Listings</h3>
        <ul>
          <li>
            <p v-if="loading">Loading...</p>
            <p v-else-if="summaryListing">
              <textarea
                class="form-control"
                :readonly="true"
                :value="JSON.stringify(summaryListing, null, 2)"
              />
            </p>
            <p v-else>No API listing for this survey.</p>
            <p>
              <a href="/api/sap/list?api_key=123" target="_blank">View summary listings.</a>
            </p>
          </li>
          <li>
            <p v-if="loading">Loading...</p>
            <p v-else-if="fullListing">
              
              <button
                class="btn btn-secondary mb-1"
                type="button"
                @click="fullListingExpanded = !fullListingExpanded"
              >
                <span>{{ fullListingExpanded ? 'Hide' : 'Show' }}</span>
                <i 
                  :class="`fas fa-sort-${fullListingExpanded ? 'up' : 'down'}`"
                  role="presentation"
                />
              </button>
              <textarea
                :class="`form-control ${fullListingExpanded ? 'open' : 'closed'}`"
                :readonly="true"
                :value="JSON.stringify(fullListing, null, 2)"
              />
            </p>
            <p v-else>No data for this survey.</p>
            <p>
              <a :href="`/api/sap/project/${survey}`" target="_blank">View full project listing.</a>
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <h3>Linked Purchases</h3>
        <div v-if="purchases.length" class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th v-for="column in purchaseColumns" :key="column">
                  {{ column }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="purchase in purchases" :key="purchase.id">
                <td v-for="column in purchaseColumns" :key="column">
                  {{ purchase[column] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else-if="loading">Loading...</p>
        <p v-else>No linked purchases.</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <h3>Missing Files</h3>
        <div class="table-responsive" v-if="Object.keys(missingFiles).length">
          <table class="table">
            <thead>
              <tr>
                <th>Field</th>
                <th>File(s)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(files, field) in missingFiles" :key="field">
                <td>{{ field }}</td>
                <td>
                  <ul>
                    <li v-for="file in files" :key="file">{{ file }}</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else-if="loading">Loading...</p>
        <p v-else>No missing files.</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'survey-sap',
  props: {
    survey: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      fullListing: false,
      fullListingExpanded: false,
      loading: false,
      missingFiles: [],
      purchases: [],
      quoteNumber: '',
      summaryListing: false,
      rloading: false,
      syncLogs: []
    }
  },
  computed: {
    purchaseColumns() {
      return this.purchases.length
        ? Object.keys(this.purchases[0])
        : []
    },
    summaries() {
      if(this.loading) {
        return ['logs', 'purchase', 'files', 'listing'].map(key => ({
          key,
          classes: 'info',
          text: 'Loading...',
        }));
      } else {
        const summaries = [];
        const lastSync = this.syncLogs[0];
        const syncError = lastSync && lastSync.RESFLAG === 'N';
        const syncSuccess = lastSync && lastSync.RESFLAG === 'Y';

        if(lastSync) {
          if(syncError) {
            summaries.push({
              key: 'logs',
              classes: 'danger',
              text: 'Error on latest sync.'
            });
          } else {
            summaries.push({
              key: 'logs',
              classes: 'success',
              text: 'No error on latest sync.'
            });
          }
        } else {
          summaries.push({
            key: 'logs',
            classes: 'warning',
            text: 'No sync logs found.',
          });
        }

        if(this.purchases.length) {
          if(this.purchases.find(purchase => !purchase.sap_id)) {
            summaries.push({
              key: 'purchase',
              classes: syncError ? 'danger' : 'warning',
              text: 'Purchase(s) without linked SAP IDs found in database.'
            });
          } else {
            summaries.push({
              key: 'purchase',
              classes: syncSuccess
                ? 'success'
                : 'warning',
              text: 'Purchase(s) and SAP ID(s) registered in site database.'
            });
          }
        } else {
          summaries.push({
            key: 'purchase',
            classes: 'warning',
            text: 'No purchase(s) found in site database.',
          });
        }

        if(this.summaryListing) {
          summaries.push({
            key: 'listing',
            classes: syncError
              ? 'danger' 
              : (lastSync 
                ? 'warning'
                : 'info'
                ),
            text: 'Survey listed on site API.',
          });
        } else {
          summaries.push({
            key: 'listing',
            classes: lastSync ? 'success' : 'warning',
            text: 'No listing for survey on site API.',
          });
        }

        if(Object.keys(this.missingFiles).length) {
          summaries.push({
            key: 'files',
            classes: 'danger',
            text: 'Missing files detected.',
          });
        } else {
          summaries.push({
            key: 'files',
            classes: 'success',
            text: 'No missing files detected.',
          });
        }

        return summaries;
      }
    }
  },
  methods: {
    load() {
      this.loading = true;

      this.$http
        .get(`/api/sap/info/${this.survey}`)
        .then(response => {
          if(!response) {
            throw('No response.');
          }

          if(!response.data) {
            throw('No response data.');
          }

          const data = response.data;

          this.fullListing = data.fullListing;
          this.missingFiles = data.missingFiles;
          this.quoteNumber = data.quoteNumber;
          this.purchases = data.purchases;
          this.summaryListing = data.summaryListing;
          this.syncLogs = data.syncLogs;
        })
        .catch(error => {
          console.error(error);
          alert('There was a problem loading the data. Please refresh the page.');
        })
        .finally(() => {
          this.loading = false;
        })
    },
    resync() {
      this.rloading = true;
      this.$http
        .get(`/api/sap/resync/${this.survey}`)
        .then(response => {
          console.log(response);
          alert('Resync has been triggered, please check wihtin 5 minutes.');
        })
        .finally(() => {
          this.rloading = false;
        })
    },
    syncLogClasses(syncLog) {
      const classes = [];

      if(syncLog.ERRORREMAR) {
        classes.push('error');
      }

      if(syncLog.SURVEYSTATUS === 'PURCHASED') {
        classes.push('success');
      }

      return classes;
    },
  },
  beforeMount() {
    this.load();
  }
}
</script>
<style lang="scss">
  .survey-sap {
    textarea {
      display: block;
      min-height: 5em;
      transition: height .25s ease-in-out;

      &.open {
        height: 25em;
        max-height: 25em;
      }

      &.closed {
        height: 5em;
        max-height: 5em;
      }
    }

    li {
      & > i {
        margin-right: .5em;
      }

      &.danger {
        color: #f5365c;
      }

      &.success {
        color: #2dce89;
      }

      &.warning {
        color: #fb6340;
      }
    }
  }
</style>